export const CroppedCoverImage = ({ src, crop, alt, testid, width, height, onError }) => {
  if (!crop) return <img data-testid={testid} src={src} alt={alt} width={width} height={height} loading="lazy" onError={onError} className="block w-full h-auto" />;
  const position = (offset, size) => size >= 0.999999 ? 50 : Math.min(100, Math.max(0, offset / (1 - size) * 100));
  return (
    <span data-testid={testid} role="img" aria-label={alt} className="block w-full bg-stone-100" style={{ aspectRatio: crop.aspect, backgroundImage: `url(${JSON.stringify(src)})`, backgroundRepeat: "no-repeat", backgroundSize: `${100 / crop.width}% ${100 / crop.height}%`, backgroundPosition: `${position(crop.x, crop.width)}% ${position(crop.y, crop.height)}%` }}>
      <img data-testid={`${testid}-source`} src={src} alt="" aria-hidden="true" hidden onError={onError} />
    </span>
  );
};
